export interface HoverTooltipRect {
  left: number
  top: number
  right: number
  bottom: number
  width: number
  height: number
}

/** Текст чипа категорий/действий ПД. Совпадает с правилами panel `::after`. */
export function purpCatChipTooltipText(input: {
  description?: string | null
  source?: string | null
  selected?: boolean
}): string {
  const description = input.description?.trim() ?? ''
  const source = input.source?.trim() ?? ''
  if (input.selected && source && description) {
    return `Источник данных: ${source}\n${description}`
  }
  if (input.selected && source) {
    return `Источник данных: ${source}`
  }
  return description
}

export function purpCatChipTooltipTextFromElement(el: Element): string {
  return purpCatChipTooltipText({
    description: el.getAttribute('data-description'),
    source: el.getAttribute('data-source'),
    selected: el.classList.contains('purp-cat-chip--selected'),
  })
}

/**
 * Фиксированная позиция. Центр над якорем, но не левее/правее окна:
 * `::after` с `left:50%` этого не умеет и обрезается overflow карточки.
 */
export function placeSpdHoverTooltip(options: {
  rect: HoverTooltipRect
  tipWidth: number
  tipHeight: number
  viewportWidth: number
  viewportHeight: number
  gap?: number
  placement?: 'above' | 'side'
}): { left: number; top: number } {
  const gap = options.gap ?? 8
  const { rect, tipWidth, tipHeight, viewportWidth, viewportHeight } = options
  const maxLeft = Math.max(gap, viewportWidth - tipWidth - gap)
  const maxTop = Math.max(gap, viewportHeight - tipHeight - gap)
  const clamp = (value: number, max: number) => Math.min(Math.max(gap, value), max)

  if (options.placement === 'side') {
    let left = rect.right + gap
    if (left + tipWidth > viewportWidth - gap) {
      left = rect.left - tipWidth - gap
    }
    const top = rect.top + rect.height / 2 - tipHeight / 2
    return {
      left: Math.round(clamp(left, maxLeft)),
      top: Math.round(clamp(top, maxTop)),
    }
  }

  const left = rect.left + rect.width / 2 - tipWidth / 2
  let top = rect.top - tipHeight - gap
  if (top < gap) top = rect.bottom + gap
  return {
    left: Math.round(clamp(left, maxLeft)),
    top: Math.round(clamp(top, maxTop)),
  }
}
